import { render, staticRenderFns } from "./RecordDeal.vue?vue&type=template&id=60ce28cc&scoped=true&"
import script from "./RecordDeal.vue?vue&type=script&lang=js&"
export * from "./RecordDeal.vue?vue&type=script&lang=js&"
import style0 from "./RecordDeal.vue?vue&type=style&index=0&id=60ce28cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce28cc",
  null
  
)

export default component.exports